module.exports = __webpack_public_path__ + "static/media/advertFolder.f91ff902.pdf";